import { Col, Row } from 'antd';
import Modal, { useConfirmModal } from 'components/Modal';
import Toast from 'components/Toast';
import { TrustPersonInfo } from 'modules/Security/type';
import deleteIcon from 'static/images/delete.png';
import editIcon from 'static/images/edit.png';
import API from 'utils/API';
import http from 'utils/http';
import { printf } from 'utils/i18n';
import AddContactModal from '../AddContactModal';
import './style.scss';

interface ContactPersonListProps {
    listData: TrustPersonInfo[];
    getData: () => void;
}

const ContactPersonList: React.FC<ContactPersonListProps> = ({ listData, getData }) => {
    const { open } = useConfirmModal();
    const handleDelete = (id, index) => {
        open({
            title: printf(__(`Are you sure you want to delete Trusted Contact Person %s？`), index + 1),
            className: 'contact-delete-confirm-root',
            okText: __('Delete'),
            cancelText: __('Cancel'),
            onOk: async () => {
                try {
                    Toast.loading(true);
                    await http.delete(API.CUSTOMER.deleteTrustedPerson(id));

                    getData();
                } catch (error) {
                    Toast.show(error);
                }

                Toast.loading(false);
            }
        });
    };

    const handleEdit = async (data: TrustPersonInfo) => {
        Modal.open({
            component: props => <AddContactModal isEdit {...props} $defaultValues={data} />,
            className: 'trust-add-contact-modal-root',
            closable: true
        })
            .result.then(() => getData())
            .catch(() => {});
    };

    return (
        <div className="contact-person-list">
            {listData.map((item, index) => {
                const {
                    id,
                    first_name,
                    middle_initial,
                    last_name,
                    tel_code,
                    phone,
                    home_address,
                    home_address2,
                    home_city,
                    home_state_code,
                    country,
                    home_postal,
                    email,
                    relationship
                } = item;

                return (
                    <div key={id} className="contact-person-item">
                        <div className="item-header">
                            <h3 className="header-title">
                                {printf(__(`Registered Trusted Contact Person %s`), index + 1)}
                            </h3>
                            <div className="header-btn-box">
                                <button className="btn-operate mr-3" onClick={() => handleEdit(item)}>
                                    <img src={editIcon} alt="edit" />
                                </button>
                                <button className="btn-operate" onClick={() => handleDelete(id, index)}>
                                    <img src={deleteIcon} alt="delete" />
                                </button>
                            </div>
                        </div>
                        <div className="item-body">
                            <Row className="item-info">
                                <Col span="10" className="item-info-key">
                                    {__('Name')}
                                </Col>
                                <Col span="14" className="item-info-value">{`${first_name} ${
                                    middle_initial && middle_initial
                                } ${last_name}`}</Col>
                            </Row>
                            <Row className="item-info">
                                <Col span="10" className="item-info-key">
                                    {__('Phone Number')}
                                </Col>
                                <Col span="14" className="item-info-value">
                                    (+{tel_code}) {phone}
                                </Col>
                            </Row>
                            <Row className="item-info">
                                <Col span="10" className="item-info-key">
                                    {__('Address')}
                                </Col>
                                <Col span="14" className="item-info-value">
                                    {home_address}, {home_address2 && `${home_address2},`} {home_city},{' '}
                                    {home_state_code}, {country}, {home_postal}
                                </Col>
                            </Row>
                            <Row className="item-info">
                                <Col span="10" className="item-info-key">
                                    {__('E - mail')}
                                </Col>
                                <Col span="14" className="item-info-value">
                                    {email}
                                </Col>
                            </Row>
                            <Row className="item-info">
                                <Col span="10" className="item-info-key">
                                    {__('Relationship')}
                                </Col>
                                <Col span="14" className="item-info-value">
                                    {relationship}
                                </Col>
                            </Row>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default ContactPersonList;
